exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reachus-component .reachus-chat{padding:24px}.reachus-component .reachus-chat__image{padding:0 24px}.reachus-component .reachus-chat__form-holder .form-control{width:60%}.reachus-component .reachus-infos{padding:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/reachus.scss
// module id = 1026
// module chunks = 0